<template>
  <div>
    <div class="icon-container" v-b-modal="objectid" @mouseover="swapImage" @mouseout="swapImage">
      <img :src="currentIcon" width="19" height="20" alt="Trash can" class="icon-image">
      <div class="icon-overlay"></div>
    </div>
    <b-modal :id="objectid" size="sm" button-size="lg" centered hide-header hide-footer hide-backdrop>
      <div class="delete-location-modal">
        <p class="delete-location-modal-title">Confirmation</p>
        <span class="delete-location-modal-message">Are you sure you want to delete {{ this.name }} from {{ this.getTripById(this.tripId).name }}?</span>
        <hr />
        <div class="confirm-delete">
          <a href="javascript:void(0);" @click="$bvModal.hide(`${objectid}`)" class="cancel-tx">Cancel</a>
          <div class="spacer"></div>
          <a href="javascript:void(0);" @click="deleteLocationFromTrip()" class="delete-tx">Delete</a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import { mapActions, mapGetters } from 'vuex';

export default {
  props: {
    objectid: {
      type: String,
    },
    tripId: {
      type: String,
    },
    slug: {
      type: String,
    },
    name: {
      type: String,
    },
    locs: {
      type: Array,
    },
  },
  data() {
    return {
      currentIcon: '/images/icons/trash.svg',
      hoverIcon: '/images/icons/trash-hover.svg',
    };
  },
  methods: {
    ...mapActions({
      loadMyTrips: 'myTrips/loadMyTrips',
      editTrip: 'myTrips/editTrip',
    }),
    swapImage() {
      [this.currentIcon, this.hoverIcon] = [this.hoverIcon, this.currentIcon];
    },
    async deleteLocationFromTrip() {
      this.isLoading = [];
      const inOtherTrips = [];
      try {
        const user = await Auth.currentAuthenticatedUser({ bypassCache: true });
        const trip = await this.getTripById(this.tripId);
        const filteredTripInfo = [...trip.tripInfo].filter(info => info.locationId !== this.objectid);
        const updatedTrip = {
          owner: user.username,
          tripId: trip.tripId,
          name: trip.name,
          locations: trip.locations,
          routing: {
            begin: {
              lat: trip.routing.begin.lat,
              long: trip.routing.begin.long,
              city: trip.routing.begin.city,
              state: trip.routing.begin.state,
            },
            end: {
              lat: trip.routing.end.lat,
              long: trip.routing.end.long,
              city: trip.routing.end.city,
              state: trip.routing.end.state,
            },
          },
          tripInfo: filteredTripInfo,
        };
        this.$bvModal.hide(`${this.objectid}`);
        await this.editTrip(updatedTrip);
        // Remove waypoint from map
        setTimeout(() => {
          this.$root.$emit('updateWaypoints');
        }, 100);
        setTimeout(() => {
          this.$bvToast.toast('Location deleted.', {
            title: 'Location deleted!',
            autoHideDelay: 3000,
            appendToast: this.append,
          });
        }, 100);
        if (updatedTrip.tripInfo.length === 0) {
          setTimeout(() => {
            // eslint-disable-next-line
            location.reload();
          }, 500);
        }
        if (this.trips && this.trips.length > 0) {
          for (let i = 0; i < this.trips.length; i++) {
            const e = this.trips[i];
            for (let j = 0; j < e.tripInfo.length; j++) {
              const x = e.tripInfo[j].locationId;
              if (x === this.objectid) {
                inOtherTrips.push(x);
              }
            }
          }
        }
        if (inOtherTrips && inOtherTrips.length <= 1) {
          this.$root.$emit('disableHeart', this.$props.objectid);
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log('Deleting location failed!', err);
      }
    },
  },
  computed: {
    ...mapGetters({
      trips: 'myTrips/myTrips',
      getTripById: 'myTrips/getTripById',
    }),
  },
};
</script>

<style scoped>
.icon-container {
  position: relative;
  display: inline-block;
}

.icon-image {
  position: relative;
  z-index: 2;
}

.icon-overlay {
  position: absolute;
  top: -7px;
  left: -10px;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  padding: 10px;
  background-color: #173945;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.icon-container:hover .icon-overlay {
  opacity: 1;
}

.delete-location-modal {
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  margin: 0 auto;
  padding: 12px;
  text-align: center;
  opacity: 1;
}

.delete-location-modal-title,
.delete-location-modal-message {
  font-family: 'IdealSans-Semibold';
  font-size: 17px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #000;
  margin-bottom: 0;
}

.delete-location-modal-message {
  width: 238px;
  font-family: 'IdealSans-Book';
  font-weight: normal;
  font-size: 13px;
}

.confirm-delete {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  cursor: pointer;
}

.cancel-tx,
.delete-tx {
  font-family: 'IdealSans-Medium';
  font-size: 17px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: #173945;
}

.cancel-tx:hover,
.delete-tx:hover {
  text-decoration: underline;
}

.cancel-tx {
  margin-right: 5px;
}

.delete-tx {
  margin-left: 5px;
}
</style>
